export default "__VITE_ASSET__BfXG8zBN__"